import dynamic from 'next/dynamic';
import React from 'react';
import { match } from 'ts-pattern';

import { ArtworkLeaderboard, MagicIcon, PromptLeaderboard, SparklingIcon } from '@/assets';
import type { UserTopLeaderboard } from '@/types/leaderboard';

import { TabKey } from '.';

const DynamicTableTopUser = dynamic(() => import('./TableTopUser'));

// const listTask = [
//   {
//     icon: <LikeGradient />,
//     content: 'Invite a friend',
//     point: 30,
//   },
//   {
//     icon: <MagicWandGradient />,
//     content: 'Gen an artwork (Midjourney, Dall-E)',
//     point: 1,
//   },
//   {
//     icon: <UploadGradient />,
//     content: 'Staking earn AIG',
//   },
// ];

export const getIconLeaderboard = (key: TabKey, className?: string) =>
  match(key)
    .with(TabKey.aig, () => <SparklingIcon className={className} />)
    .with(TabKey.artwork, () => <ArtworkLeaderboard className={className} />)
    .with(TabKey.prompt, () => <PromptLeaderboard className={className} />)
    .with(TabKey.topCreator, () => <MagicIcon className={className} />)
    .otherwise(() => null);

const TopUser: React.FC<{
  activeTab: TabKey;
  listAll: UserTopLeaderboard[];
}> = ({ activeTab, listAll }) => {
  return (
    <div className="flex justify-center">
      <div className="w-[100%]">
        {/* <div className="flex justify-center pb-[45px] lg:block">
          <div className="shadow-2 w-[500px] max-w-full rounded-[10px] bg-gradient-to-r from-[#DA613A] to-purple-800 p-[2px] lg:w-[100%]">
            <div className="h-full w-full rounded-[8px] bg-white px-3 py-[18px]">
              <div>
                <h1 className="text-20 font-semibold leading-[34px] text-black text-center">Task List</h1>
                <div className="flex items-center justify-between rounded-lg bg-orange-50 px-4 py-[18px]">
                  <div className="w-[70%] text-14 font-normal leading-5 text-gray-700">
                    Log in daily to claim AIG points. Each week will earn 140 AIG at most.
                  </div>
                  <div className="flex text-16 font-bold leading-6">
                    <IconAIG20px />
                    +140 AIG
                  </div>
                </div>
                {listTask.map((task) => (
                  <div className="flex items-center justify-between px-4 pt-[22px] ">
                    <div className="flex w-[75%] text-14 font-normal leading-5 text-gray-700">
                      <span className="pr-3">{task.icon}</span>
                      {task.content}
                    </div>
                    {task.point && (
                      <div className="flex text-16 font-bold leading-6">
                        <IconAIG20px />+{task.point} AIG
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div> */}

        <DynamicTableTopUser listAll={listAll} activeTab={activeTab} />
      </div>
    </div>
  );
};

export default TopUser;
